import React, {useState} from 'react';
import {Row} from 'react-table';
import styled from 'styled-components';

import {defineMessage} from '../../../../../libs/shared/helpers/src/internationalization/message';
import {useDebounce} from '../../../../../libs/shared/helpers/src/react/hooks/hookHelpers';
import {TextBox} from '../../../../../libs/shared/ui/src/components/boxedInputs/textBox';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {useLocalize} from '../../../../../srcCommon/internationalization/internationalizationContext';

/*
 * Props.
 */

interface TableGlobalFilterProps<T extends object> {
  preGlobalFilteredRows: Array<Row<T>>;
  globalFilter: string;
  setGlobalFilter: (filterValue: string) => void;
}

/*
 * Styles.
 */

const StyledTextBox = styled(TextBox)`
  width: 224px;
`;

/*
 * Component.
 */

export const TableGlobalFilter = <T extends object>({
  globalFilter,
  setGlobalFilter,
}: TableGlobalFilterProps<T>) => {
  const [value, setValue] = useState(globalFilter);
  const localize = useLocalize();
  const onGlobalFilterChange = useDebounce(setGlobalFilter, 200);

  return (
    <StyledTextBox
      size={VisualSizesEnum.MEDIUM}
      placeholder={localize(
        defineMessage({
          id: 'table-search-placeholder',
          message: 'Search',
        }),
      )} // TODO add search icon in placeholder
      value={value || ''}
      onChange={(e) => {
        setValue(e);
        onGlobalFilterChange(e);
      }}
      noMargin
    />
  );
};
